module.exports = __webpack_public_path__ + "img/m4.cf5549fa.png";